Pixlee.module('SingleEmbedsApp.Embed', function(Embed, App, Backbone, Marionette, $) {
	Embed.Controller = App.Controllers.Application.extend({
		initialize: function(options) {
            var _this = this;
            this.view = this.getView();
            this.SingleEmbedLayout = this.getLayout();
            this.listenTo(this.SingleEmbedLayout, "show", this.onLayoutShow);
            _this.show(_this.SingleEmbedLayout, {
                region: App.widgetsRegion
            });
        },
        getView: function() {
            var _this = this;
            this.model = App.request('get:photo', gon.current_album_photo_id);
            return new Embed.Item({
                model: _this.model
            });
        },
        onLayoutShow: function() {
            var _this = this;
            _this.show(_this.view, {
                region: this.SingleEmbedLayout.embed_region
            });
        },
        getLayout: function(options) {
            var config;
            var _this = this;
            if (options == null) {
                options = {};
            }
            return new Embed.Layout();
        },
        onImageRendered: function() {
            
        }
	});

});